// Exchange — chip rail. Pure presentation. Counts come from
// `countByChip` in exchange-derive.ts and are passed in.

import type { ChipId } from "./exchange-derive.ts";

interface Chip {
  id: ChipId;
  label: string;
  count: number;
}

interface Props {
  active: ChipId;
  onChange: (id: ChipId) => void;
  counts: Record<ChipId, number>;
}

export function ExchangeChipRail({ active, onChange, counts }: Props): JSX.Element {
  const chips: readonly Chip[] = [
    { id: "all", label: "All", count: counts.all },
    { id: "tier1", label: "Tier 1 leagues", count: counts.tier1 },
    { id: "ghana", label: "Ghana Premier", count: counts.ghana },
    { id: "btts", label: "BTTS", count: counts.btts },
    { id: "overunder", label: "Over/Under", count: counts.overunder },
    { id: "dc", label: "Double Chance", count: counts.dc },
    { id: "ah", label: "Asian Handicap", count: counts.ah },
    { id: "today", label: "Today / tomorrow", count: counts.today },
    { id: "weekend", label: "This weekend", count: counts.weekend },
  ];
  return (
    <div className="chip-rail">
      {chips.map((c) => (
        <button
          key={c.id}
          className={`chip ${active === c.id ? "on" : ""}`}
          onClick={() => onChange(c.id)}
          type="button"
        >
          {c.label}
          {c.count > 0 ? <span className="ct">{c.count}</span> : null}
        </button>
      ))}
    </div>
  );
}
